import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/firebase/firestore'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    posts: []
  },
  actions: {
    LOAD_POSTS: function ({ commit }) {
      let posts = []
      db.collection('posts').get()
      .then( snapshot => {
        snapshot.forEach( doc => {
          let post = doc.data()
          post.id = doc.id
          post.active = true
          post.filter = false
          posts.push(post)
        })
      })
      .catch( err => {
        console.log("error", err.message)
      })
      commit('SET_POSTS', { posts: posts })
    }
  },
  mutations: {
    SET_POSTS: (state, { posts }) => {
      state.posts = posts
    },
    FILTER_BY_TYPE: (state, filter) => {
      state.posts.forEach((post) => {
        if(post.type == filter || filter == '') {
          post.active = true
        } else {
          post.active = false
        }
      })
    },
    FILTER_BY_QUERY: (state, query) => {
      query = query.toLowerCase()
      state.posts.forEach((post) => {
        if(!query) {
          post.filter = false
        } else {
          if(post.active) {
            post.filter = true
            if( 
              post.title.toLowerCase().indexOf(query) !== -1 ||
              post.description.toLowerCase().indexOf(query) !== -1 ||
              post.content.toLowerCase().indexOf(query) !== -1 ||
              post.type.indexOf(query) !== -1
            ) {
              post.filter = false
            } else {
              // Now we check the tags since it is more expensive
              post.tags.forEach((tag) => {
                if( tag.indexOf(query) !== -1 ) {
                  post.filter = false
                }
              })
            }
          }
        }
      })
    }
  },
  getters: {

  }
})
export default store